export const IconWithdraw = (props: any) => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.16666 2.66602L3.99999 3.66602L4.83332 2.66602"
        stroke="#FDFDFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 2.33291C1.5 2.33291 2.75 0.416234 4.91667 1.16624C7.08333 1.91624 7 4.08291 7 4.08291"
        stroke="#FDFDFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 5.66667C6.5 5.66667 5.5 7.5 3.25 6.91667C1 6.33333 1 4 1 4"
        stroke="#FDFDFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 1.33398V4.00065" stroke="#FDFDFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 4V6.66667" stroke="#FDFDFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 4.66602H5" stroke="#FDFDFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 3.66602H5" stroke="#FDFDFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 3.66602V5.66602" stroke="#FDFDFD" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
